// Defer bootstrap so webpack Module Federation can initialize shared modules
// before Angular tries to eager-load them (fixes standalone dev-server testing).
import('./bootstrap').catch((err) => console.error(err));
